<template lang="html">
	<tr>
		<table-cell class="campaign-table-name">
			<div class="campaign-table-name__title">
				<a :href="builderLink" class="omapi-link-title">{{ leadCampaign.name }}</a>
			</div>
			<div class="campaign-table-name__type">{{ leadCampaign.type }}</div>
		</table-cell>
		<table-cell class="campaign-table-created">
			{{ created }}
		</table-cell>
		<table-cell class="campaign-table-stats">
			<core-button :is-link="true" :link-style="true" @click.prevent="go()">{{ allTime }}</core-button>
		</table-cell>
		<table-cell class="campaign-table-stats">
			<core-button :is-link="true" :link-style="true" @click.prevent="go('30-days')">{{ last30 }}</core-button>
		</table-cell>
	</tr>
</template>

<script lang="js">
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('monsterleads')

export default  {
	props : {
		leadCampaign : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		created () {
			return this.$store.getters.adjustUserTimezone(
				this.$moment(this.$get('leadCampaign.created') || Date.now()),
			).format('MM/DD/YYYY')
		},
		allTime () {
			return this.$get('leadCampaign.leads_count_all_time', 0) || 0
		},
		last30 () {
			return this.$get('leadCampaign.leads_count_30_days', 0) || 0
		},
		/**
		 * Get the path to edit this campaign.
		 *
		 * @param {string} campaignId The campaign id/slug.
		 * @returns {string} The URI
		 */
		builderLink () {
			return this.$urls.builderLink(this.$get('leadCampaign.slug'))
		},
	},
	methods : {
		...mapActions([ 'fetchLeadsFromDateRange', 'goToCampaignFilteredPage' ]),
		go (filter = '') {
			this.goToCampaignFilteredPage(this.$get('leadCampaign.id', 0))
			this.fetchLeadsFromDateRange({
				filter,
				start : '',
				end   : '',
			})
		},
	},
};
</script>
